import { createContext } from 'react';

const NavbarMenuContext = createContext({});

export default NavbarMenuContext;
